import { useTranslation } from 'react-i18next';
import { Card, CardBody } from 'reactstrap';

import { Vulnetability } from 'api/periodReports/type';

const SanitarVulDataElement: React.FC<{ data: Vulnetability }> = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Card
      className="card shadow-hover"
      style={{
        backgroundColor: data.fix_date === 'Не усунено!' ? 'rgba(255, 28, 28, 0.08)' : 'inherit',
      }}
    >
      <a target="_blank" href={`${process.env.REACT_APP_BASE_DJANGO_URL}/trap/info/${data.id}`} rel="noreferrer">
        <CardBody>
          <div className="d-lg-flex align-items-center">
            {/* Column 1 1 */}
            <div className="col-lg-1 text-center">
              <div>
                <i
                  title={t('VulnerabilityList.accordion.accordion-inner-a-titles.sanitar')}
                  className="ri-recycle-fill text-warning fs-3"
                />
              </div>
            </div>

            {/* Column 2 2 */}
            <div className="col-lg-1">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">{data.vul_pk}</h5>
                <p className="text-muted text-center mb-0">№</p>
              </div>
            </div>

            {/* Column 3 4 */}
            <div className="col-lg-2">
              <div className="ms-4">
                <h5
                  className={`fs-16 text-center mb-2 ${data.criticality === 'Критичний' || data.criticality === 'Критичний (Негайно!)' ? 'text-danger' : ''}`}
                >
                  {data.criticality}
                </h5>

                <p className="text-muted text-center mb-0">
                  {t('VulnerabilityList.accordion.accordion-inner.criticality')}
                </p>
              </div>
            </div>

            {/* Column 4 6 */}
            <div className="col-lg-2">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">{data.responsible}</h5>
                <p className="text-muted text-center mb-0">
                  {t('VulnerabilityList.accordion.accordion-inner.resonsive-person')}
                </p>
              </div>
            </div>

            {/* Column 5 8 */}
            <div className="col-lg-2">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">{data.inspector}</h5>
                <p className="text-muted text-center mb-0">
                  {t('VulnerabilityList.accordion.accordion-inner.inspector')}
                </p>
              </div>
            </div>

            {/* Column 6 10 */}
            <div className="col-lg-2">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">{data.create_date}</h5>
                <p className="text-muted text-center mb-0">
                  {t('VulnerabilityList.accordion.accordion-inner.create-date')}
                </p>
              </div>
            </div>

            {/* Column 7 12 */}
            <div className="col-lg-2">
              <div className="ms-4">
                {data.fix_date === 'Не усунено!' ? (
                  <h5 className="fs-16 text-center text-danger mb-2">{data.fix_date}</h5>
                ) : (
                  <h5 className="fs-16 text-center mb-2">{data.fix_date}</h5>
                )}

                <p className="text-muted text-center mb-0">
                  {t('VulnerabilityList.accordion.accordion-inner.last-date')}
                </p>
              </div>
            </div>
          </div>
        </CardBody>
      </a>
    </Card>
  );
};

export default SanitarVulDataElement;
